import React from 'react';
import { connect } from 'dva';
import { framework_tool,component_tool } from '@/tool'
import { templateConfig, reduxTemplateConfig } from './config'
const { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport} = component_tool;

const excelTitleEnum = {
  content: '内容管理',
  learningMaterials: '学习资料管理'
}

class ContentManage extends WizContainer {

  componentName = 'contentManage';

  constructor(props) {
    super(props);
    this.state = {}

    let { history } = props
    if (history.location && history.location.pathname === '/content/learningMaterialsManage') {
      this.hiddenType = 'learningMaterials';
    } else {
      this.hiddenType = 'content';
    }
  }


  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '标题',
        field: 'title',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      this.hiddenType === 'content' ? {
        headerName: '标签',
        field: 'labelNames',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }: null,
      // {
      //   headerName: '元素图标',
      //   field: 'icon',
      //   width: 500,
      //   cellStyle: {
      //     textAlign: 'center',
      //   },
      //   style: {
      //     alignment: { vertical: 'bottom', horizontal: 'center' },
      //   },
      // },
      {
        headerName: '内容分类',
        field: 'categoryNames',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '内容类型',
        field: 'contentType',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '作者',
        field: 'author',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '发布平台',
        field: 'releasePlatform',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'releaseState',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '是否置顶',
        field: 'switchTop',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '发布时间',
        field: 'releaseTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '受众',
        field: 'scope',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center', wrapText: true  },
        },
      }
    ].filter(item => !!item)

    if (o['success']) {
      let data = o['data']
      let _data = []
      const contentTypeMap = { '1': "文章", '2': "图片", '3': "视频", '4': "文档", '5': "下载文件" };
      const map = { '1': "PC", '2': 'APP' }
      const releaseMap = { '0': "草稿", '1': '已发布', '2': '取消发布', '3': '已关闭' }
      const topMap = { '0': "否", '1': '是'}
      if(data && data instanceof Array && data.length>0){
        data.forEach(p=>{
          const textArr = p['releasePlatform'].split(',');
          const arr = [];
          for (let index = 0; index < textArr.length; index++) {
            arr.push(map[textArr[index]])
          }
          p['contentType'] = contentTypeMap[p['contentType']]
          p['releaseState'] = releaseMap[p['releaseState']]
          p['switchTop'] = topMap[p['switchTop']]

          p['releasePlatform'] =  arr.join(',')
          let _p = { ...p }
          let authData = p['authData']
          let target = ''
            if (authData && Object.keys(authData)) {
              if (authData['orgIds'] && authData['orgIds'].length) {
                target += ' 组织范围：'
                authData['orgIds'].forEach(org => {
                  target += org['name'] + ','
                });
                target += '\n'
              }
              if (authData['positionIds'] && authData['positionIds'].length) {
                target += ' 岗位：'
                authData['positionIds'].forEach(org => {
                  target += org['name'] + ','
                });
                target += '\n'
              }
              if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
                target += ' 岗位分类：'
                authData['positionCategoryIds'].forEach(org => {
                  target += org['name'] + ','
                });
                target += '\n'
              }
              if (authData['personIds'] && authData['personIds'].length) {
                target += ' 指定人员：'
                authData['personIds'].forEach(org => {
                  target += org['userName'] +'('+org['fullName'] +'),'
                });
                target += '\n'
              }
            }
            _p['scope'] = target
            _data.push(_p)
        })
      }
      WizBrowserExport({
        title: excelTitleEnum[this.hiddenType],
        sheetName: excelTitleEnum[this.hiddenType],
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: excelTitleEnum[this.hiddenType] + '.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      hiddenType: this.hiddenType,
      templateConfig: templateConfig(this.hiddenType),
      apiDataFormat: {
        update: this._handleCMD,
        enable: this._handleCMD,
        export:this._handleFile.bind(this),
        delete: this._handleCMD,
        changeTop: this._handleCMD,
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ContentManage);
